<di-search
           title="Client"
           searchPlaceholder="Search"
           [columns]="columns"
           [pageDTO]="pageDTO">

</di-search>